import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group.types';
import {
  GetHeaderV2Response_TargetGroupItem,
  GetHeaderV2Response_TargetGroupSwitch,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  darkTheme,
} from '@aboutyou/ui-components';
import React, {useEffect, useRef} from 'react';
import styled, {css} from 'styled-components';
import {Link} from '../../../features/Link/Link';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';

export const BrandPageGenderSwitch: React.FC<{
  className?: string;
  targetGroups: GetHeaderV2Response_TargetGroupItem[];
  targetGroupSwitch?: GetHeaderV2Response_TargetGroupSwitch;
}> = ({className, targetGroups = [], targetGroupSwitch}) => {
  const hasUpdatedOnMount = useRef(false);
  const {
    targetGroup: cookieTargetGroup,
    initialTargetGroup: cookieInitialTargetGroup,
  } = useSelectedTargetGroup();
  const initialTargetGroup = useRef<TargetGroup>(
    targetGroupSwitch?.targetGroup ?? cookieTargetGroup,
  );

  useEffect(() => {
    if (
      !hasUpdatedOnMount.current &&
      cookieInitialTargetGroup === cookieTargetGroup
    ) {
      hasUpdatedOnMount.current = true;
      initialTargetGroup.current = cookieTargetGroup;
    }
  }, [cookieInitialTargetGroup, cookieTargetGroup]);

  if (targetGroups.length < 2) {
    return null;
  }

  const handleOnClick = (targetGroup: TargetGroup) => () => {
    initialTargetGroup.current = targetGroup;
  };

  return (
    <section className={className} data-testid="brandGenderSwitch">
      {targetGroups.map(element => (
        <StyledGender
          key={element.targetGroup}
          label={element.label}
          linkTarget={element.shopPath}
          data-active={element.targetGroup === initialTargetGroup.current}
          onClick={handleOnClick(element.targetGroup)}
        />
      ))}
    </section>
  );
};

const StyledGender = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  min-width: 52px;
  height: 100%;
  box-sizing: content-box;
  color: ${COLORS.Grey1};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.bold};
  line-height: 18px;
  transition: color 0.5s;
  text-decoration: none;
  text-transform: uppercase;

  ${darkTheme(css`
    color: ${COLORS.Grey2};
  `)}

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    margin: auto;
    width: 24px;
    height: 2px;
    background: ${COLORS.Black};
    transform: scale(0);
    transition: transform 0.5s ease;

    ${darkTheme(css`
      background: ${COLORS.White};
    `)}
  }

  &[data-active='true'],
  :hover {
    color: ${COLORS.Black};
    font-weight: ${FONT_WEIGHTS.heavy};

    &::after {
      transform: scale(1);
    }

    ${darkTheme(css`
      color: ${COLORS.White};
    `)}
  }

  &:hover {
    color: ${COLORS.Black};

    ${darkTheme(css`
      color: ${COLORS.White};
    `)}
  }
`;
